import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.clients_api.client_waitlist;

// Helper function to configure the Axios instance with auth interceptor
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

export const createWaitlistRecord = async (data: any) => {
  try {
    const response: any = await retryWithBackoff(() => api.post('/CreateWaitlistRecord', data));
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error;
  }
};

export const deleteWaitlistRecordById = async (waitlist_id: number) => {
  try {
    const response: any = await retryWithBackoff(() => api.delete(`/DeleteWaitlistRecordByRecordId/${waitlist_id}`));
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error;
  }
};

export const getClientWaitlistByLocalId = async (local_id: number) => {
  try {
    const response: any = await retryWithBackoff(() => api.get(`/GetClientWaitlistByLocalId/${local_id}`));
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error;
  }
};